
  import moment from 'moment';
  import authorByAuthorTagCode from '@/apollo/queries/blog/authorByAuthorTagCode'
  import blogsByAuthorTagCode from '@/apollo/queries/blog/blogsByAuthorTagCode'
  
  export default {
    layout: 'white',
    data() {
      return {
        blogAuthors: Array,
        blogs: Array,
        blogsMeta: Array,
        loading: 0,
        filters: {
          tagCodes: [],
          authorTagCodes: [],
        },
      };
    },
    head() {
      const headData = {
        title: this.stripHtmlTags(this.blogAuthors?.[0]?.BlogAuthorInformation?.AuthorName) || this.$t('blog.authorAllArticles'),
        meta: [
          {
            hid: 'og:title', name: 'og:title', property: 'og:title',
            content: this.stripHtmlTags(this.blogAuthors?.[0]?.BlogAuthorInformation?.AuthorName) || this.$t('blog.authorAllArticles'),
          },
          {
            hid: 'og:description', name: 'og:description', property: 'og:description',
            content: this.stripHtmlTags(this.blogAuthors?.[0]?.BlogAuthorInformation?.Description) || '',
          },
          {
            hid: 'description',
            name: 'description',
            content: this.stripHtmlTags(this.blogAuthors?.[0]?.BlogAuthorInformation?.Description) || '',
          },
          {
            hid: 'og:image', name: 'og:image', property: 'og:image',
            content: this.blogAuthors?.[0]?.BlogAuthorInformation?.AuthorImage?.url || '',
          },
        ],
      };

      if (this.blogAuthors?.[0]?.PageSchema?.jsonSnippet) {
        try {
          const schema = this.blogAuthors[0].PageSchema.jsonSnippet;
          headData.script = [
            {
              type: 'application/ld+json',
              json: schema,
              hid: 'structured-data',
            },
          ];
        } catch (e) {
          console.warn('Failed to process jsonSnippet from CMS:', e);
        }
      } else {
        console.error('No jsonSnippet found - skipping schema');
      }

      return headData;
    },

    computed: {
        BlogFiltersTagCodes () {
            return this.$store.getters['blog/filtersTagCodes']
        },
        BlogFiltersAuthorCodes() {
            return this.$store.getters['blog/filtersAuthorCodes']
        },
    },
      methods: {
      getFilterAuthor() {
        return [this.$route.params.slug]
      },
      stripHtmlTags(text) {
        if (!text) return '';
        return text.replace(/<[^>]*>/g, '');
      }
    },

    apollo: {
      $loadingKey: "loading",
      blogAuthors: {
        prefetch: true,
        query: authorByAuthorTagCode,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , tagCode: this.$route.params.slug, today: moment().format('YYYY-MM-DD')};
        },
        update(data) {
          return this.$normalizeStrapi(data.blogAuthors.data);
        },
      },
      blogs: {
        prefetch: true,
        query: blogsByAuthorTagCode,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) , authorTagCode: this.$route.params.slug};
        },
        update(data) {
          this.blogsMeta = data.blogs.meta
          // return this.$normalizeStrapi(data.blogs.data);
          return this.$normalizeStrapi(data.blogs);
        },
      },
      
    },
  }
